// Copied from Acend
import {
  FormControl as ChakraFormControl,
  InputProps,
  Stack,
  StackDirection,
} from "@chakra-ui/react";
import React from "react";

export interface FormControlProps extends InputProps {
  direction?: StackDirection;
}

const FormControl = ({
  children,
  isRequired,
  isInvalid,
  isDisabled,
  isReadOnly,
  direction,
  ...restProps
}: FormControlProps) => {
  return (
    <Stack
      as={ChakraFormControl}
      isRequired={isRequired}
      isInvalid={isInvalid}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      direction={direction}
      spacing={direction === "row" ? 2 : 0}
      {...restProps}
    >
      {children}
    </Stack>
  );
};

export default FormControl;
